import { render, staticRenderFns } from "./DetailCoupon.vue?vue&type=template&id=1208c102&"
import script from "./DetailCoupon.vue?vue&type=script&lang=js&"
export * from "./DetailCoupon.vue?vue&type=script&lang=js&"
import style0 from "./DetailCoupon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports